"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowTypes = exports.Arrow = void 0;
var _react = _interopRequireDefault(require("react"));
var _BaseSvg = require("./BaseSvg");
var _utils = require("../utils");
var _excluded = ["type", "className", "size"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var ArrowTypes = ['sub-arrow', 'arrow-short', 'arrow-angle', 'arrow-long-left', 'arrow-long-right', 'arrow-long-down', 'arrow-long-up'];
exports.ArrowTypes = ArrowTypes;
var Arrow = function Arrow(_ref) {
  var type = _ref.type,
    className = _ref.className,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  switch (type) {
    case 'sub-arrow':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 10.159L9.465 5.497 9.39 5.43a.57.57 0 00-.776.092l-.062.083a.696.696 0 00.084.842l2.848 2.927H4.054l-.102-.007c-.298-.043-.504-.27-.504-.508V1.785l-.007-.106C3.393 1.295 3.091 1 2.724 1c-.4 0-.724.351-.724.785V8.86l.006.158a2.065 2.065 0 002.048 1.927h7.43L8.634 13.87l-.065.08a.697.697 0 00.043.845.57.57 0 00.852.025L14 10.159z"
        }));
      }
    case 'arrow-short':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M8.294 2.08l.084.06 6.425 5.372.056.064.028.039.011.017a.705.705 0 01.043.653l-.054.1-.053.07-.073.072-6.383 5.334a.587.587 0 01-.866-.12.708.708 0 01.036-.862l.074-.073 4.953-4.14H1.617C1.277 8.667 1 8.369 1 8c0-.335.228-.612.526-.66l.091-.007h10.958l-4.953-4.14a.702.702 0 01-.165-.843l.055-.091a.59.59 0 01.692-.222l.09.043z"
        }));
      }
    case 'arrow-angle':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.702 2a.75.75 0 000 1.5h7.653L2.22 12.715a.758.758 0 000 1.065.742.742 0 001.056 0l9.227-9.306v7.912a.75.75 0 001.5 0V2.75a.75.75 0 00-.75-.75h-9.55z"
        }));
      }
    case 'arrow-long-left':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.6644 4.74742C11.0771 4.3805 11.1143 3.74843 10.7474 3.33565C10.3805 2.92286 9.74842 2.88568 9.33564 3.2526L0.338028 11.2505C0.307433 11.2775 0.278505 11.3064 0.25142 11.337C0.0949855 11.5134 2.37061e-06 11.7456 0 12C0 12 0 12 0 12C0 12.2996 0.1317 12.5683 0.340353 12.7516L9.33564 20.7474C9.74842 21.1143 10.3805 21.0772 10.7474 20.6644C11.1143 20.2516 11.0771 19.6195 10.6644 19.2526L3.63021 13H23C23.5523 13 24 12.5523 24 12C24 11.4477 23.5523 11 23 11H3.63019L10.6644 4.74742Z"
        }));
      }
    case 'arrow-long-right':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.336 4.747a1 1 0 011.328-1.494l8.998 7.998A.996.996 0 0124 12c0 .3-.132.568-.34.752l-8.996 7.995a1 1 0 01-1.328-1.494L20.37 13H1a1 1 0 110-2h19.37l-7.034-6.253z"
        }));
      }
    case 'arrow-long-down':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.747 13.336a1 1 0 10-1.494 1.328l7.998 8.998A.996.996 0 0012 24c.3 0 .568-.132.752-.34l7.995-8.996a1 1 0 10-1.494-1.328L13 20.37V1a1 1 0 10-2 0v19.37l-6.253-7.034z"
        }));
      }
    case 'arrow-long-up':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.253 10.664a1 1 0 001.494-1.328L12.75.338A.994.994 0 0012 0c-.3 0-.568.132-.752.34L3.253 9.336a1 1 0 001.494 1.328L11 3.63V23a1 1 0 102 0V3.63l6.253 7.034z"
        }));
      }
    default:
      {
        throw new Error((0, _utils.getErrorMessage)(type));
      }
  }
};
exports.Arrow = Arrow;